"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var InputNumber =
/** @class */
function (_super) {
  __extends(InputNumber, _super);

  function InputNumber(props) {
    var _this = _super.call(this, props) || this;

    _this.onChange = function (event) {
      var value = event.currentTarget.value;

      _this.setState({
        value: value
      });

      var numericValue = parseFloat(value);

      if (_this.props.onChange) {
        if (!isNaN(numericValue)) {
          _this.props.onChange(event);
        } else {
          var modifiedEvent = __assign(__assign({}, event), {
            currentTarget: __assign(__assign({}, event.currentTarget), {
              value: '0'
            }),
            target: __assign(__assign({}, event.target), {
              value: '0'
            })
          });

          _this.props.onChange(modifiedEvent);
        }
      }
    };

    _this.state = {
      value: props.value
    };
    return _this;
  }

  InputNumber.getDerivedStateFromProps = function (props, state) {
    // tslint:disable:triple-equals
    if (state.value != props.value && !(props.value === 0 && state.value === '')) {
      return {
        value: props.value
      };
    }

    return null;
  };

  InputNumber.prototype.render = function () {
    var _a = this.props,
        inputRef = _a.inputRef,
        rest = __rest(_a, ["inputRef"]);

    return react_1.default.createElement("input", __assign({}, rest, {
      ref: this.props.inputRef,
      type: "number",
      value: this.state.value,
      onChange: this.onChange
    }));
  };

  return InputNumber;
}(react_1.default.Component);

exports.default = react_1.default.forwardRef(function (props, inputRef) {
  var ref = props.ref,
      rest = __rest(props, ["ref"]);

  return react_1.default.createElement(InputNumber, __assign({}, rest, {
    inputRef: inputRef
  }));
});